import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { login } from '@/api/login'
import { organization } from '@/api/organization'
import { getOrganizationName, setOrganizationName, removeCookies} from '@/utils/cookies'
import { resetRouter } from '@/router'
import store from '@/store'

import { Md5 } from 'ts-md5/dist/md5'
import Cookies from 'js-cookie'

export interface IUserState {
  organizationName: string
  name: string
  avatar: string
  introduction: string
  roles: string[]
  email: string
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public organizationName = getOrganizationName() || ''
  public name = ''
  public avatar = ''
  public introduction = ''
  public roles: string[] = []
  public email = ''
  public organizationId = Cookies.get('organizationId')

  @Action
  public async Login(userInfo: { username: string, password: any}) {
    let { username, password } = userInfo
    password = Md5.hashStr(password)
    username = username.trim()
    const data: any = await login(username, password)
    if (data.status === 4001) {
      Cookies.set('userName', data.userName)
      setOrganizationName(data.organizationName)
      this.SET_ORGANIZATION_NAME(data.organizationName)
      if (data.organizationName === '超级管理员') {
        Cookies.set('organizationId', '')
        Cookies.set('wyOrganizationId', '')
      } else {
        Cookies.set('organizationId', data.organizationId)
        Cookies.set('wyOrganizationId', data.wyOrganizationId)
      }
    }
    return data.status
  }

  @Action
  public ResetOrganizationName() {
    removeCookies()
    this.SET_ROLES([])
    this.SET_ORGANIZATION_NAME('')
  }

  @Action
  public async GetUserInfo() {
    const data: any = await organization('GET', { id: Cookies.get('organizationId') }, null, '/UserInfo')
    console.log('roles is:', data.roles)
    const roles = data.roles
    // roles must be a non-empty array
    if (!roles || roles.length <= 0) {
      throw Error('GetUserInfo: roles must be a non-null array!')
    }
    this.SET_ROLES(roles)
  }

  @Action
  public async LogOut() {
    if (this.organizationName === '') {
      throw Error('LogOut: organizationName is undefined!')
    }
    // await logout()
    removeCookies()
    resetRouter()
    this.SET_ROLES([])
    this.SET_ORGANIZATION_NAME('')
  }

  @Mutation
  private SET_ORGANIZATION_NAME(organizationName: string) {
    this.organizationName = organizationName
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
    this.roles = roles
  }
}

export const UserModule = getModule(User)
